import {Event, Reflection, Type} from 'main.core';
import {Overlay, SHOWN_EVENT, HIDDEN_EVENT} from "citrus.aproduction3.overlay";

const namespace = Reflection.namespace('BX.Citrus.Aproduction3');

let instance = undefined;

const defaultOptions = {isOpen: false, id: undefined};

const OPEN_CLASSES = {
    body: ['_menu'],
    element: ['b-h__burger_active'],
};

export class Burger extends Event.EventEmitter {
    constructor(options = defaultOptions) {
        options = Object.assign({}, defaultOptions, options || {});
        super();
        this.setEventNamespace('BX.Citrus.Aproduction3.Burger');

        if (!Type.isBoolean(options.isOpen)) {
            throw new Error('Wrong isOpen value');
        }

        instance = this;

        this.overlay = Overlay.getInstance();
        this.overlay.subscribe(SHOWN_EVENT, (e) => {
            if (e.data.actor !== this) {
                this.internalClose();
            }
        });
        this.overlay.subscribe(HIDDEN_EVENT, (e) => {
            if (e.data.actor === this) {
                this.close();
            }
        });

        this.isOpen = !!options.isOpen;
        this.element = options.element || document.querySelector('.b-h__burger');
        this.body = document.body;
        this.element.addEventListener('click', event => this.onClick(event))
        this.updateState();
    }

    /**
     * @returns {Burger}
     */
    static getInstance() {
        return instance;
    }

    onClick(event) {
        event.preventDefault();
        this.toggle();
    }

    updateState() {
        const method = this.isOpen ? 'add' : 'remove';

        this.element.classList[method](...OPEN_CLASSES.element);
        this.body.classList[method](...OPEN_CLASSES.body);
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.isOpen = true;
        this.updateState();
        this.overlay.show(this);
        this.emit('onOpen');
    }

    close() {
        this.overlay.hide(this);
        this.internalClose();
    }

    internalClose() {
        this.isOpen = false;
        this.updateState();
        this.emit('onClose');
    }
}

namespace.Burger = Burger;
